import { TextField, MenuItem } from '@mui/material';
import { TERM_OPTIONS } from '../constants/yearGroups';

/**
 * Academic term dropdown — Term 1 / Term 2 / Term 3. Stored as those exact
 * strings (matches the Invoice.term enum). Props forwarded to MUI TextField.
 */
export default function TermSelect({
    value,
    onChange,
    label = 'Term',
    allowAny = true,
    anyLabel = 'Any',
    size = 'small',
    ...rest
}) {
    return (
        <TextField
            select
            size={size}
            label={label}
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            {...rest}
        >
            {allowAny && <MenuItem value="">{anyLabel}</MenuItem>}
            {TERM_OPTIONS.map((t) => (
                <MenuItem key={t} value={t}>
                    {t}
                </MenuItem>
            ))}
        </TextField>
    );
}
